import { QuestionCircleOutlined } from "@ant-design/icons";
import { Color } from "@types";
import { styled } from "styled-components";
import { IconProps } from "./types";

export const QuestionInfoTypeIcon = styled(QuestionCircleOutlined)<IconProps>`
  font-size: ${({ width = 22 }) => `${width}px;`}
  color: ${({ color = Color.SecondaryBase }) => `${color};`}
`;
